import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import FirmCalendar from "./Calendar";
import { GlobalContextProvider } from "./Utils/GlobalContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalContextProvider>
      <FirmCalendar />
    </GlobalContextProvider>
  </React.StrictMode>
);
